import React from 'react';
export function Section4Temple() {
  return <section className="w-full bg-[#f8f9fa] py-16 px-4 border-b border-gray-200" data-id="element-91">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-92">
        <div className="bg-navy-900 text-white p-8 md:p-12 shadow-xl border-t-4 border-gold-500 text-center" data-id="element-93">
          <h2 className="text-sm font-bold tracking-widest uppercase text-gold-500 mb-4" data-id="element-94">
            EL HALLAZGO QUE CAMBIÓ NUESTRA INVESTIGACIÓN:
          </h2>
          <h3 className="text-3xl md:text-5xl font-serif font-bold leading-tight" data-id="element-95">
            EL TEMPLO LA LUZ DEL MUNDO
          </h3>
        </div>

        <div className="space-y-6 text-lg text-gray-800 font-serif leading-relaxed max-w-3xl mx-auto" data-id="element-96">
          <p data-id="element-97">
            Llegamos al Templo La Luz Del Mundo en Miami, Florida, sin
            anunciarnos.
          </p>
          <p data-id="element-98">Sin cita previa. Sin identificarnos como investigadores.</p>
          <p data-id="element-99">Llegamos como cualquier persona que busca ayuda.</p>
          <p className="font-bold text-navy-900" data-id="element-100">
            Lo que presenciamos en los días siguientes cambió completamente la
            perspectiva de toda nuestra investigación.
          </p>
        </div>

        <div className="bg-navy-900 text-white p-8 border border-gold-500 shadow-lg max-w-3xl mx-auto" data-id="element-101">
          <h4 className="text-xl font-bold text-gold-500 mb-6 uppercase tracking-wide border-b border-gray-700 pb-4" data-id="element-102">
            TEMPLO DE AYUDA LA LUZ DEL MUNDO
          </h4>
          <ul className="space-y-4 text-lg font-serif" data-id="element-103">
            <li className="flex items-start gap-3" data-id="element-104">
              <span className="text-gold-500 font-bold" data-id="element-105">•</span>
              <span data-id="element-106">
                <strong className="font-sans tracking-wide" data-id="element-107">Ubicación:</strong>{' '}
                Miami, Florida
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-108">
              <span className="text-gold-500 font-bold" data-id="element-109">•</span>
              <span data-id="element-110">
                <strong className="font-sans tracking-wide" data-id="element-111">
                  Años de operación verificados:
                </strong>{' '}
                Más de 45 años
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-112">
              <span className="text-gold-500 font-bold" data-id="element-113">•</span>
              <span data-id="element-114">
                <strong className="font-sans tracking-wide" data-id="element-115">
                  Casos documentados:
                </strong>{' '}
                15,000+
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-116">
              <span className="text-gold-500 font-bold" data-id="element-117">•</span>
              <span data-id="element-118">
                <strong className="font-sans tracking-wide" data-id="element-119">
                  Director Espiritual:
                </strong>{' '}
                Maestro Mayor — reconocido internacionalmente
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-120">
              <span className="text-gold-500 font-bold" data-id="element-121">•</span>
              <span data-id="element-122">
                <strong className="font-sans tracking-wide" data-id="element-123">Método:</strong>{' '}
                Técnicas ancestrales transmitidas de generación en generación
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-124">
              <span className="text-gold-500 font-bold" data-id="element-125">•</span>
              <span data-id="element-126">
                <strong className="font-sans tracking-wide" data-id="element-127">
                  Principio ético:
                </strong>{' '}
                Ningún trabajo para dañar — ningún trabajo forzado
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-128">
              <span className="text-gold-500 font-bold" data-id="element-129">•</span>
              <span data-id="element-130">
                <strong className="font-sans tracking-wide" data-id="element-131">Cobertura:</strong>{' '}
                Todo el territorio de Estados Unidos
              </span>
            </li>
          </ul>
        </div>

        <div className="space-y-6 text-lg text-gray-800 font-serif leading-relaxed max-w-3xl mx-auto pt-8" data-id="element-132">
          <p data-id="element-133">La diferencia fue evidente desde el primer momento.</p>

          <ul className="space-y-2 pl-4 border-l-4 border-gold-500 my-6" data-id="element-134">
            <li data-id="element-135">Sin diagnósticos de maldiciones fabricadas.</li>
            <li data-id="element-136">Sin presión para pagar.</li>
            <li data-id="element-137">Sin promesas imposibles.</li>
            <li data-id="element-138">Sin urgencia artificial.</li>
          </ul>

          <p data-id="element-139">Solo una evaluación honesta de la situación.</p>
          <p data-id="element-140">Solo preguntas reales.</p>
          <p data-id="element-141">Solo orientación genuina.</p>

          <p className="font-bold text-xl text-navy-900 mt-8" data-id="element-142">
            Pero lo que más nos impactó no fue lo que decían.
          </p>

          <p className="italic text-gray-600" data-id="element-143">Fue lo que presenciamos.</p>
        </div>
      </div>
    </section>;
}